<script setup lang="ts">
  import { refDebounced } from '@vueuse/core'

  useHead({ titleTemplate: (title) => `${title ? title + ' - ' : ''}juss recipes` })
  const router = useRouter()
  const route = useRoute()
  const layout = ref<HTMLElement | null>(null)

  const searchQuery = computed(() => route.query.search as string)
  const searchInput = ref(searchQuery.value || '')
  const search = refDebounced(searchInput, 250)
  watch(search, (value) => router.replace({ query: value ? { search: value } : {} }))
  watch(searchQuery, (value) => (searchInput.value = value))
  provide('searchInput', searchInput)
  provide('search', search)

  // FIXME: fix FOUC only on first load
  onMounted(() => {
    setTimeout(() => {
      if (layout.value) layout.value.style.opacity = '1'
    }, 200)
  })
</script>

<template>
  <VitePwaManifest />
  <NuxtPwaManifest />
  <NuxtPwaAssets />
  <div ref="layout" style="opacity: 0">
    <Nav />
    <OfflineIndicator />
    <main>
      <slot />
    </main>
    <SpeedInsights />
  </div>
</template>

<style>
  .page-enter-active,
  .page-leave-active {
    @apply transition;
  }

  .page-enter-from,
  .page-leave-to {
    @apply opacity-0;
  }
</style>
